import { sharedConstants } from 'shared-helpers';

// from shared-helpers
export const ALLOWED_QUERY_OPERATOR = sharedConstants.ALLOWED_QUERY_OPERATOR;
export const TAXONOMIES = sharedConstants.TAXONOMIES;
export const COOKIE_NAME = sharedConstants.COOKIE_NAME;
export const USER_STATUS = sharedConstants.USER_STATUS;
export const TELEPHONE_REGEX = sharedConstants.TELEPHONE_REGEX;

// Every fund of one manager in a single request (the API's default page is 20, which would hide the rest): the Fund
// Portfolio pills and the Direct Investments fund tabs list up to this many
export const MAX_FUNDS_PER_MANAGER = 100;

// regex
export const PLAY_STORE_LINK_REGEX = /(https:\/\/)?(play\.google\.com\/)[\w\d?@%&$+~=*#/._-]+/;
export const APP_STORE_LINK_REGEX = /(https:\/\/)?(apps\.apple\.com\/)[\w\d?@%&$+~=*#/._-]+/;
export const ITUNES_STORE_LINK_REGEX = /(https:\/\/)?(itunes\.apple\.com\/)[\w\d?@%&$+~=*#/._-]+/;

export const JOB_STATUS = {
    draft: 0,
    published: 1,
    unPublished: 2
}

// map segmentation list for startup directory landscape view grouping
export const MAP_SEGMENTATION_LIST = [
    { key: 'isCountry', name: 'Country', type: "country" },
    { key: 'isCity', name: 'City', type: "city" },
    { key: 'isPrimaryIndustry', name: 'Primary Industry', type: "industry" },
    { key: 'isSubIndustry', name: 'Sub Industry', type: "sub_industry" },
    { key: 'isBusinessType', name: 'Business Type', type: "business" },
    { key: 'isLastStage', name: 'Last Stage Raised', type: "stage" }
]

export const PPT_LANDSCAPE_VIEW_TYPES = [
    MAP_SEGMENTATION_LIST.find(item => item.type === 'country').type,
    MAP_SEGMENTATION_LIST.find(item => item.type === 'industry').type,
]

export const FIELD_SEPARATOR = "^,"
export const EQUAL_SYMBOL = "^:"
export const VALUE_SEPARATOR = "^;"
// export const DEFAULT_TEAM_ROLE = 6578;

// It's team role like founder, CTO etc.
export const DEFAULT_TEAM_ROLE = 9;

// It's an access role which indicates that what user can do
export const TEAM_EDIT_ROLE_ID = 17;

export const MAX_LIMIT = 300;

export const PERIODS = [
    { id: 'YEAR', name: 'Per Year' },
    { id: 'MONTH', name: 'Per Month' },
    { id: 'WEEK', name: 'Per Week' },
    { id: 'DAY', name: 'Per Day' },
    { id: 'HOUR', name: 'Per Hour' },
]

export const FILTER_LAYOUT_TYPES = {
    ecosystem: 'ecosystem',
    investors: 'investors',
    lps: 'lps',
    startups: 'startups',
    company: 'company',
    jobs: 'jobs',
    funds: 'funds',
    privateEquity: 'privateEquity',
    dfhq: 'dfhq'
}

// Synthetic region option appended to taxonomy-driven region filters, mirroring Advanced Analytics.
// It has no taxonomy region row of its own, so it resolves directly to these constituent countries
// rather than a region-based location lookup.
export const PAK_TURKEY_REGION = { id: 'pak-turkey', name: 'Pakistan & Turkey', type: 'list' };

// Synthetic region option resolving to locations outside the known taxonomy regions, excluding Pakistan & Turkey.
export const OTHER_REGIONS = { id: 'other-regions', name: 'Other Regions', type: 'list' };

export const DEF_MAGNITT_DESCRIPTION = "MAGNiTT is your go-to platform for verified Venture Capital and Private Equity insights across the Middle East, Africa, Southeast Asia, Türkiye and Pakistan. Empower your investment decisions with comprehensive research, dynamic dashboards, and exportable data - all designed to help you move faster, see further, and make smarter moves in emerging venture markets.";

export const MENA_COUNTRIES_IDS = [5664, 5674, 5713, 5740, 5746, 5751, 5755, 5778, 5791, 5794, 5802, 5812, 5824, 5827, 5832, 5841, 5847, 5856]
export const PAKISTAN_COUNTRY_ID = 5792
export const TURKEY_COUNTRY_ID = 5842
export const UAE_COUNTRY_ID = 5847;

// Constituent countries the synthetic PAK_TURKEY_REGION option resolves to
export const PAK_TURKEY_COUNTRIES = [
    { id: PAKISTAN_COUNTRY_ID, name: 'Pakistan' },
    { id: TURKEY_COUNTRY_ID, name: 'Türkiye (Turkey)' }
];

const northAfricaRegionID = {
    development: 18810,
    production: 135278
}
const NORTH_AFRICA_REGION_ID = northAfricaRegionID[process.env.NODE_ENV];

const regionIDs = {
    development: {
        mena: [6503, NORTH_AFRICA_REGION_ID],    // combined Middle East and North Africa
        africa: [18822, 18808, NORTH_AFRICA_REGION_ID],
        southeastAsia: [18823]
    },
    production: {
        mena: [135277, NORTH_AFRICA_REGION_ID],   // combined Middle East and North Africa
        africa: [135279, NORTH_AFRICA_REGION_ID], // combined Sub-Saharan Africa and North Africa
        southeastAsia: [135286]
    }
}
export const REGION_IDS = regionIDs[process.env.NODE_ENV];

export const TOP_INDUSTRIES_IDS = [15, 31, 1, 45, 16, 26, 34, 21, 48, 36, 10, 22, 47, 19, 13, 14, 37, 28, 38, 7]

export const EXCEPTION_INDUSTRIES_SLASH = ['ar-vr', 'professional-corporate-services']
export const EXCEPTION_INDUSTRIES_AND = ['travel-and-tourism', 'network-and-community', 'hr-and-recruitment', 'food-and-beverage', 'fashion-and-beauty', 'delivery-and-logistics']

export const EXCEPTION_INVESTOR_TYPES = {
    'crowd-funder': 'crowd-funder',
    'venture-capital-vc': 'venture capital (vc)',
    'corporate-vc-cvc': 'corporate vc (cvc)',
    'co-working-space': 'co-working space'
}

export const FUNDING_STATUS = {
    pending: 0,
    verified: 1,
    unverified: 2,
    draft: 3
}

const fundingStages = {
    development: {
        bridge: 6697,
        acquisition: 6699,
        undisclosed: 6686,
        venture_undisclosed: 6823,
        private_equity: 6913,
        ipo: 6914
    },
    production: {
        bridge: 6697,
        acquisition: 6699,
        undisclosed: 6787,
        venture_undisclosed: 6686,
        private_equity: 6823,
        ipo: 6822
    }
}

export const FUNDING_STAGES = fundingStages[process.env.NODE_ENV];

const jobTypes = {
    development: {
        intern: 6731
    },
    production: {
        intern: 6741
    }
}

export const TEXT_LIMIT_TO_SHOW_MORE = 900;

export const JOB_TYPES = jobTypes[process.env.NODE_ENV];

const northstar_entity_id = {
    development: 51948,
    production: 52037
}

export const NORTHSTAR_ENTITY_ID = northstar_entity_id[process.env.NODE_ENV]

export const DIRECTORY_STARTUPS = [
    {
        name: 'Startups in UAE',
        link: '/en-ae/startups'
    },
    {
        name: 'Startups in KSA',
        link: '/en-sa/startups/'
    },
    {
        name: 'Startups in Egypt',
        link: '/en-eg/startups/'
    },
    {
        name: 'Startups in Pakistan',
        link: '/en-pk/startups/'
    },
    {
        name: 'Startups in Turkey',
        link: '/en-tr/startups/'
    }
];

export const DIRECTORY_INVESTORS = [
    {
        name: 'Venture Capital (VC) in United Arab Emirates (UAE)',
        link: '/en-ae/investors/venture-capital-vc'
    },
    {
        name: 'Angel Group in Saudi Arabia (KSA)',
        link: '/en-sa/investors/angel-group'
    },
    {
        name: 'Accelerator in Egypt',
        link: '/en-eg/investors/accelerator'
    },
];

// data exports
export const DATA_SET_TYPES = {
    startups: 'STARTUP',
    ecosystem: 'ECOSYSTEM',
    investor: 'INVESTOR',
    lps: 'LP',
    lpCommitments: 'LP COMMITMENTS',
    investorFunds: 'INVESTOR FUNDS',
    investorInvestments: 'INVESTOR INVESTMENTS',
    funding: 'FUNDING',
    funds: 'FUND',
    privateEquity: 'PRIVATE EQUITY',
    company: 'COMPANY',
    custom: 'CUSTOM'
}

// contact forms type
export const CONTACT_FORM_TYPE = {
    marketing: 1,
    enterprise: 2,
    demo_request: 3,
    bespoke_report: 4
}

// mapping of form source in hubspot
export const HUBSPOT_FORM_SOURCE = {
    homepage_demo: 'demo_homepage',
    about_us: 'demo_about_us',
    dir_locked_contacts: 'sales_directory_contact',
    single_profile_locked_contacts: 'sales_profile_contact',
    single_profile_locked_sections: 'sales_profile_preview',
    dir_locked_startups_landscape_view: 'sales_directory_startup',
    demo_dir_widget: 'demo_directory',
    startups_dir_locked_section: 'sales_directory_startup',
    investor_dir_locked_section: 'sales_directory_investor',
    exits_dir_locked_section: 'sales_directory_exits',
    funds_dir_locked_section: 'sales_directory_funds',
    private_equity_dir_locked_section: 'sales_directory_private_equity',
    research_purchase_btn: 'sales_report_purchase',
    research_widgets: 'sales_report_content',
    analytics: 'sales_analytics',
    marketing_widgets: 'sales_news',
    marketing: 'sales_advertisewithus',
    custom_market_map: 'sales_marketmap',

    // mapping for pricing page
    pricing_contact_sales: 'sales_pricing',
    pricing_request_demo: 'demo_pricing',
    pricing_bespoke_report: 'sales_pricing_report',
    pricing_free_demo_trial: 'demo_pricing_faq',
    sales_pricing_popup: 'sales_pricing_popup',

    enterprise_form: 'sales_enterprise',
    bespoke_report: 'sales_enterprise_report',
    demo_request: 'demo_enterprise',
    contact_sales: 'support_contactus',
    faq: 'demo_faq',
    download_success: 'demo_report_download',
    directory_presentation: 'sales_directory_presentation',
    privateequity_demo: 'demo_privateequity',
    sales_privateequity: 'sales_privateequity',
}

// Personal Dashboard - recent funding insufficient data message
export const DASHBOARD_INSUFFICIENT_DATA = "There are no recorded fundings for the last 4 weeks";

// directory pagination
export const RECORD_COUNT_OPTIONS = [10, 25, 50, 100];
export const RECORD_COUNT_DEFAULT = {
    default: RECORD_COUNT_OPTIONS[0],
    loggedOut: 5
}

// Valuation for Directory and Single SICE page
export const VALUATION_INFO_TEXT = {
    actual: "This range represents the actual valuation at the time of funding",
    estimate: "This range represents an estimate for the valuation at the time of funding, using many data points including stage, geography and industry",
    owner: "This range can be adjusted by editing the information in this Funding round to include the actual post-money valuation. This will always be presented as a range"
}

export const PENDING_INFO_TEXT = {
    not_owner: "This funding information has not been verified by a member of our team",
    owner: "This funding information has not been verified by a member of our team, to get your data verified please contact us"
}

export const SAVED_TEMPLATE_TYPES = {
    marketMapStartup: 'startup_market_map',
    marketMapInvestor: 'investor_market_map'
}

export const HELPDESK_LINKS = {
    directories: "https://knowledgebase.magnitt.com",
    analytics: "https://knowledgebase.magnitt.com"
}

// Single Startup Benchmarking Tool
export const STARTUP_BENCHMARKING_HEADERS = [
    { label: 'Company Profile', key: 'company-profile' },
    { label: 'Latest Funding', key: 'latest-funding' },
    { label: 'Investor(s)', key: 'investors-data' },
    { label: 'Exit', key: 'exit-data' },
    { label: 'Team Size and Org', key: 'team-data' },
    { label: 'Founders', key: 'founders-data' }
]

export const NO_SIMILAR_STARTUPS = "Similar startups are not available for this profile for comparison"

// Chart colors
export const BAR_COLOR = ['#D22248'];
export const BAR_LINE_CHART_COLOR = ['#D22248', '#FF8811'];
export const STACKED_BAR_LINE_COLOR = ['#D22248', '#2C373B', '#FF8811'];
export const STACKED_BAR_COLOR = ['#D22248', '#2C373B'];
export const GROUPED_STACKED_BAR_COLOR = ['#D22248', '#9FBDC1', '#2C373B'];
export const NORMALIZED_BAR_COLOR = ['#9FBDC1', '#557E85', '#40575E', '#2C373B'];
export const CANDLESTICK_BAR_COLOR = ['#2C373B', '#557E85'];
export const STACKED_BAR_COLOR_EXTENDED = ["#99254B", "#D22248", "#FF8811", "#6A7D86", "#2C373B"];
export const REGIONS_CONSTANTS = ["Southeast Asia", "Middle East", "North Africa", "Sub-Saharan Africa", "Others"];
export const STACKED_BAR_REGION_COLOR = {
    "Southeast Asia": "#99254B",
    "Middle East": "#D22248",
    "North Africa": "#FF8811",
    "Sub-Saharan Africa": "#6A7D86",
    "Others": "#2C373B"
}

REGIONS_CONSTANTS.forEach((item, index) => {
    STACKED_BAR_REGION_COLOR[item] = STACKED_BAR_COLOR_EXTENDED[index]
})

// minimum % to be displayed in the chart
// smaller values will be combined into 'other' catg
// Also used in magnitt-react update if changing this value
export const DONUT_PERCENTAGE_THRESHOLD_VAL = 5;

export const DEAL_TERM_MEANING = `This is the specific conditions and rules agreed upon by investors and startup founders when making an investment. These terms lay out the structure of the agreement between the parties.`;
export const INVESTMENT_VEHICLE_MEANING = `This is the specific mechanisms or financial instruments through which investors provide capital to startups. These vehicles allow investors to participate in the growth and success of the company.`;

export const ENTITY_TYPE = {
    startup: 'STARTUP',
    investor: 'INVESTOR',
    enabler: 'ENABLER',
    corporate: 'CORPORATE',
    fund: 'FUND',
    company: 'COMPANY',
}

export const DIRECTORY_TYPE = {
    startup: 'startup',
    ecosystem: 'ecosystem',
    funds: 'funds',
    privateEquity: 'privateEquity',
    company: 'company'
}

export const COMPONENT_NAME = {
    Startup: 'Startup',
    Company: 'Company',
    CreateDashBoard: 'CreateDashBoard'
}

export const DIRECTORY = {
    startups: 'startups',
    company: 'company',
}

export const API_ERROR_MESSAGES = {
    nameAlreadyExist: 'name already exists',
    noChangesUpdated: 'No changes updated',
}

export const FUNDING_VERIFICATION_STATUS = {
    pending: 0,
    verified: 1,
    unverified: 2,
    draft: 3
};

export const HOME_DASHBOARD_SECTION_MESSAGES = {
    map: 'Uncover trends and insights in the world of startups and venture funding, all aligned with your custom filters',
    view: 'Save your filters and search in any directory to easily track investments, startups and trends based on your interests'
}

// MISK & BIAC specific employee count chart
export const MISK_CLIENT_DIRECTORY_ID = 5;
export const BIAC_CLIENT_DIRECTORY_ID = 6;


export const CLEAR_ALL_FILTER_BTN_CLASSNAME = "clearAllFilter"

// year founded filter start value (based on oldest verified funding round data)
export const YEAR_FOUNDED_START_VALUE = 1980;

export const TECHNOLOGY_ICONS = {
    1: 'fas fa-brain',
    2: 'fas fa-microchip',
    3: 'fas fa-vr-cardboard',
    4: 'fas fa-link',
    5: 'fas fa-cloud',
    6: 'fas fa-wifi',
    7: 'fas fa-leaf',
    8: 'fas fa-atom',
    9: 'fas fa-rocket',
    10: 'fas fa-robot',
    11: 'fas fa-memory',
    12: 'fas fa-broadcast-tower'
};

// event name to update saved views across components
export const UPDATE_SAVED_VIEW_EVENT = 'update-saved-view-event';

// Password Policy
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).+$/;

const magnitt_domain = {
    development: "magtests.xyz",
    production: "magnitt.com"
};

export const MAGNITT_DOMAIN = magnitt_domain[process.env.NODE_ENV];

const dfhq_organization_id = {
    development: 36,
    production: 200
}

export const DFHQ_ORGANIZATION_ID = dfhq_organization_id[process.env.NODE_ENV]

export const D33_INDUSTRIES = [
    { id: 232, name: 'Manufacturing' },
    { id: 14, name: 'Logistics' },
    { id: 20, name: 'Financial Services' },
    { id: 48, name: 'Tourism' },
    { id: 26, name: 'Health' },
    { id: 37, name: 'Real Estate / PropTech' },
    { id: 9, name: 'Construction Tech' },
    { id: 4, name: 'AgriTech' },
    { id: 15, name: 'eCommerce / Retail' },
    { id: 16, name: 'EdTech' },
    { id: 23, name: 'Gaming' },
    { id: 7, name: 'Entertainment' },
    { id: 51, name: 'Sustainability' }
];

export const LIFECYCLE_STATUS = [
    { id: 0, name: 'Inactive' },
    { id: 1, name: 'Active' },
    { id: 2, name: 'Acquired' },
    { id: 3, name: "IPO'ed" },
];

export const FILTER_SECTION_ICONS = {
    company: 'fas fa-briefcase',
    demographics: 'fas fa-globe-africa',
    funding: 'fas fa-funnel-dollar',
    general: 'fas fa-tags',
    keyword: 'fas fa-keyboard',
    exit: 'fa fa-sign-out-alt',
    custom: 'fas fa-cog',
    key: 'fas fa-key',
};

export const FILTER_TAXONOMY_MAX_LIMIT = 300;
